import React from 'react';
import { motion } from 'framer-motion';
import { ADD_TO_CART_PAYLOAD, CHECKOUT_ANCHOR } from '../data/checkout';
import { newEventId, trackAddToCart } from '../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  href?: string;
  variant?: 'primary' | 'ghost';
  size?: 'md' | 'lg';
  className?: string;
  /** Only the button that sends the user to the Shopify cart sets this. */
  fireAddToCart?: boolean;
}

/** Small delay so the pixel request leaves before the page navigates away. */
const NAVIGATION_DELAY = 300;
export function CtaButton({
  children,
  href = CHECKOUT_ANCHOR,
  variant = 'primary',
  size = 'lg',
  className = '',
  fireAddToCart = false
}: CtaButtonProps) {
  const base = 'group relative inline-flex items-center justify-center gap-2.5 rounded-full font-semibold tracking-tight transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-400 focus-visible:ring-offset-2 focus-visible:ring-offset-noir-950';
  const sizes = {
    md: 'px-6 py-3 text-sm',
    lg: 'px-7 py-4 text-base sm:px-10 sm:py-5 sm:text-lg'
  };
  const variants = {
    primary: 'bg-crimson-600 text-white shadow-[0_18px_45px_-12px_rgba(192,24,44,0.75)] hover:bg-crimson-500 ring-1 ring-crimson-500/60',
    ghost: 'bg-transparent text-gold-400 ring-1 ring-gold-500/45 hover:bg-gold-500/10 hover:text-gold-400'
  };
  function handleClick(event: React.MouseEvent<HTMLAnchorElement>) {
    if (!fireAddToCart) return;
    trackAddToCart(ADD_TO_CART_PAYLOAD, newEventId('atc'));
    const isExternal = /^https?:\/\//i.test(href);
    const opensNewTab = event.metaKey || event.ctrlKey || event.shiftKey;
    if (!isExternal || opensNewTab || event.defaultPrevented) return;
    event.preventDefault();
    window.setTimeout(() => {
      window.location.href = href;
    }, NAVIGATION_DELAY);
  }
  return <motion.a href={href} onClick={handleClick} whileHover={{
    y: -3,
    scale: 1.015
  }} whileTap={{
    y: 0,
    scale: 0.985
  }} transition={{
    type: 'spring',
    stiffness: 420,
    damping: 24
  }} className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-63" data-mp="bfaq7t8luov4">
      <span className="relative z-10 flex items-center gap-2.5 text-center" data-id="element-64" data-mp="3hw9ogi2xvw7s">
        {children}
      </span>
      {variant === 'primary' && <span aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden rounded-full" data-id="element-65" data-mp="3rwa701szi8ax">
          <span className="absolute -left-1/3 top-0 h-full w-1/3 -skew-x-12 bg-white/25 opacity-0 blur-md transition-all duration-700 group-hover:left-[110%] group-hover:opacity-100" data-id="element-66" data-mp="9gpypt1h8vxh" />
        </span>}
    </motion.a>;
}